import { useState, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@cloudscape-design/components/box';
import Link from '@cloudscape-design/components/link';
import { APP_VERSION } from '@/lib/appVersion';
import { forceUpdate } from '@/lib/forceUpdate';
import { useAppVersionGate } from '@/lib/useAppVersionGate';

/**
 * Rodapé fixo embaixo do menu lateral: mostra a versão do admin e, quando
 * há build mais nova publicada (`/appConfig/admin`), um link "Atualizar"
 * que limpa caches/SW e recarrega. Em OK (inclusive dev local) o link não
 * aparece — espelha o UpdateLink da sidebar do app.
 *
 * Origem: sem issue — commit 17dc7b267, 2026-06-19 (version gate com force
 * update + versão embaixo do menu).
 *
 * Usado por: `routes/AdminLayout.tsx` (navegação lateral). Teste:
 * `NavVersionFooter.test.tsx`. Par bloqueante: `AppVersionGate`.
 */
export function NavVersionFooter(): JSX.Element {
  const { t } = useTranslation();
  const gate = useAppVersionGate();
  const [updating, setUpdating] = useState(false);

  return (
    <Box
      padding={{ horizontal: 'l', vertical: 's' }}
      fontSize="body-s"
      color="text-status-inactive"
    >
      {t('app.login.version', { version: APP_VERSION })}
      {gate.kind !== 'OK' && (
        <>
          {' • '}
          <Link
            variant="primary"
            onFollow={(): void => {
              setUpdating(true);
              void forceUpdate();
            }}
          >
            {updating ? t('app.common.updating') : t('app.common.update')}
          </Link>
        </>
      )}
    </Box>
  );
}
